
import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-loader-general',
  imports: [],
  templateUrl: './loader-general.component.html',
  styleUrl: './loader-general.component.css'
})
export class LoaderGeneralComponent {
@Input() loading: boolean = false;
}
